module.exports = __webpack_public_path__ + "static/side-img-4-e45c355bc3d3c2e19a00356cb3ce5119.png";